export const songEventsName = {
  PLAY_SONG: 'PLAY_SONG',
  PAUSE_SONG: 'PAUSE_SONG',
  STOP_SONG: 'STOP_SONG',
}